{
  "email": "이메일",
  "emailAddress": "이메일 주소",
  "emailAddressPlaceholder": "이메일 주소를 입력하세요",
  "continue": "계속하기",
  "send": "보내기",
  "resend": "재전송",
  "sendCodeErrorTip": "코드 전송 실패: {error}",
  "sendEmailTips": "인증 코드를 이메일로 보냈습니다",
  "verificationCode": "인증 코드",
  "codePlaceholder": "코드를 입력하세요",
  "wallet": "지갑",
  "otherLoginMethods": "다른 로그인 방법",
  "login": "로그인",
  "user": "사용자",
  "loginTitle": "로그인 / 회원가입",
  "loginTips": "다음 방법으로 로그인할 수 있습니다",
  "passwordMinError": "비밀번호는 최소 {length}자 이상이어야 합니다",
  "passwordMatchError": "두 비밀번호가 일치하지 않습니다",
  "passwordTitle": "비밀번호 설정",
  "passwordTips": "지갑 복구에 사용할 비밀번호를 설정하세요",
  "password": "비밀번호",
  "passwordPlaceholder": "비밀번호를 입력하세요",
  "rePassword": "비밀번호 확인",
  "rePasswordPlaceholder": "비밀번호를 다시 입력하세요",
  "recoverTitle": "지갑 복구",
  "recoverTips": "비밀번호를 입력해 지갑을 복구하세요",
  "bindWith": "{name} 지갑과 연결",
  "loginWith": "{name} 지갑으로 로그인",
  "editUsernameTitle": "사용자 이름 수정",
  "setUsernameTitle": "사용자 이름 설정",
  "username": "사용자 이름",
  "usernamePlaceholder": "사용자 이름을 입력하세요",
  "usernameValidError": "이름은 문자, 숫자 및 특수문자로 구성될 수 있습니다",
  "usernameLengthError": "이름은 최소 2자 이상이어야 합니다",
  "confirm": "확인",
  "nextTime": "다음에",
  "setUsername": "사용자 이름 설정",
  "disconnect": "연결 끊기",
  "CEXBindTitle": "{type} API 연결",
  "CEXBindAttention": "주의:",
  "CEXBindTips1": "1. 읽기 전용 권한으로 API를 연결해주세요.",
  "CEXBindTips2": "2. API가 오래되었을 수 있습니다. 장기적인 API를 사용하는 것이 좋습니다.",
  "CEXBindTips3": "3. 동일한 거래소에 동시에 연결할 수 있는 API는 하나뿐입니다.",
  "CEXBindApiKey": "API 키",
  "CEXBindApiSecretKey": "API 비밀 키",
  "CEXBindApiPassphrase": "API 암호 구문",
  "cancel": "취소",
  "walletLoading": "지갑 서비스를 불러오는 중",
  "tokenDetails": "토큰 상세정보",
  "tokenAmountMin": "금액은 0보다 커야 합니다.",
  "tokenAmountMax": "잔액이 부족합니다.",
  "tokenAddressError": "유효하지 않은 주소입니다.",
  "amount": "금액",
  "amountPlaceholder": "금액을 입력하세요.",
  "balance": "잔액",
  "receiveTitle": "수신 지갑 주소",
  "receivePlaceholder": "수신 지갑 주소를 입력하세요.",
  "next": "다음",
  "copied": "복사됨",
  "receiveQrcode": "QR 코드를 스캔하여 받기",
  "copyAddress": "주소 복사",
  "tokenSmartContract": "토큰 스마트 컨트랙트",
  "tokenSmartContractPlaceholder": "토큰 스마트 컨트랙트를 입력하세요.",
  "tokenSymbol": "토큰 심볼",
  "tokenSymbolPlaceholder": "토큰 심볼을 입력하세요.",
  "tokenDecimals": "소수점 자리수",
  "tokenDecimalsPlaceholder": "소수점 자리수를 입력하세요.",
  "import": "가져오기",
  "receive": "받기",
  "customizedToken": "맞춤형 토큰",
  "noMoreRecords": "여기에 더 이상 기록이 없습니다!",
  "noRecords": "여기에 기록이 없습니다!",
  "close": "닫기",
  "back": "뒤로",
  "importSuccess": "토큰을 성공적으로 가져왔습니다",
  "importFail": "토큰 가져오기에 실패했습니다",
  "changeNetwork": "네트워크 변경",
  "approveSuccess": "승인 성공",
  "Approve": "승인",
  "noFriends": "아직 친구가 없습니다",
  "noRequests": "아직 요청이 없습니다",
  "noMore": "더 이상 없음",
  "Remove": "삭제",
  "removeSuccess": "삭제 성공"

}
